import { Controller } from "@hotwired/stimulus"
import { enter, leave } from "el-transition"

export default class extends Controller {
  static targets = ["dropdown", "icon"]

  connect() {
    this.instanceId = Math.random().toString(36).substring(2, 9)
    this.closeFromEvent = this.closeFromEvent.bind(this)
    this.resetOnCache = this.resetOnCache.bind(this)

    document.addEventListener("dropdown:close-others", this.closeFromEvent)
    // Snapshot caches can preserve a stale "opened" state. Force-close on
    // connect and before Turbo caches the page so we always start clean.
    document.addEventListener("turbo:before-cache", this.resetOnCache)
    this.forceClose()
  }

  disconnect() {
    document.removeEventListener("dropdown:close-others", this.closeFromEvent)
    document.removeEventListener("turbo:before-cache", this.resetOnCache)
  }

  toggleDropdown(e) {
    e.preventDefault()
    e.stopPropagation()
    this.isOpen ? this.close() : this.open()
  }

  open() {
    document.dispatchEvent(
      new CustomEvent("dropdown:close-others", { detail: { sourceId: this.instanceId } })
    )

    enter(this.dropdownTarget)
    this.dropdownTarget.dataset.state = "opened"
    if (this.hasIconTarget) this.iconTarget.classList.add("rotate-180")
  }

  close(e) {
    // When invoked via `click@window`, ignore clicks that originated inside
    // the dropdown itself — the toggle button has already handled them.
    if (e && this.element.contains(e.target)) return
    if (!this.isOpen) return

    leave(this.dropdownTarget)
    this.dropdownTarget.dataset.state = "closed"
    if (this.hasIconTarget) this.iconTarget.classList.remove("rotate-180")
  }

  closeFromEvent(e) {
    if (e.detail.sourceId !== this.instanceId) this.close()
  }

  resetOnCache() {
    this.forceClose()
  }

  // Synchronously force the dropdown into a closed state without animating —
  // used on connect and before snapshot cache to clear any stale state.
  forceClose() {
    if (!this.hasDropdownTarget) return
    this.dropdownTarget.classList.add("hidden")
    this.dropdownTarget.dataset.state = "closed"
    if (this.hasIconTarget) this.iconTarget.classList.remove("rotate-180")
  }

  get isOpen() {
    return this.hasDropdownTarget && this.dropdownTarget.dataset.state === "opened"
  }
}
